import classNames from 'classnames';
import type { BgColors } from '../../constants';

export interface SeparatorProps {
  horizontal?: boolean;
  middle?: boolean;
  color?: BgColors;
}

export const Separator = ({
  horizontal,
  middle,
  color = 'bg-ds-natural-150',
}: SeparatorProps) => {
  const orientationStyle = horizontal
    ? `${middle ? 'w-10/12' : 'w-full'} h-px shrink-0`
    : `${middle ? 'h-3/5' : 'h-full'} w-px`;

  return <div className={classNames(color, orientationStyle)} />;
};
